import { render } from "./Close.vue?vue&type=template&id=a0df1fb8&scoped=true"
import script from "./Close.vue?vue&type=script&lang=js"
export * from "./Close.vue?vue&type=script&lang=js"

import "./Close.vue?vue&type=style&index=0&id=a0df1fb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0df1fb8"]])

export default __exports__